import { IDecimalRoundBehavior, IDecimalRoundBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { ICalculateObjectBean } from "../../../beans/objects";
import { IntegerTranslator } from "../../values";

export class DecimalRoundBehaviorTranslator {
  from(bean: ICalculateObjectBean): IDecimalRoundBehavior {
    const isEnable = (bean["@round"] !== "0");
    return {
      isEnable,
      numberOfDecimalPlaces: this.integer.from(bean["@decimal-place"]),
      kind: this.integer.from(bean["@round"]),
    };
  }

  to(object: IDecimalRoundBehaviorSpecifiable) {
    return {
      decimalPlace: this.integer.to(object.decimalRoundBehavior.numberOfDecimalPlaces),
      round: object.decimalRoundBehavior.isEnable
        ? this.integer.to(object.decimalRoundBehavior.kind)
        : "0",
    };
  }

  private readonly integer = new IntegerTranslator();
}
